import React from 'react';
import Error from './Error';

export default function NotFound({ title = "Not Found", message = "The requested resource could not be found.", buttonVisible = false, buttonFunction = () => { window.location.assign(window.location.href) }, buttonText = "Try again", ...props }) {
    return (<Error title={title} message={message} buttonVisible={ true }>{ props.children }</Error>);
}